import React from 'react';
import DropdownField from './DropdownField';
import { deepClone } from 'src/legacy/utils/helpers';
import { Choices } from '../../types/TherapistAvailabilityWidget';

// This Dropdown Container which we use here bypasses the Questionaire process for the previous Dropdown container
// We use this container to write on selecting logic to make it true while selected
// and DropdownField to write render option and input change logic

type DropdownContainerType = {
  className: string;
  onChangeValue: (choices: []) => void;
  menu: [Choices];
  title?: string;
  infoMessage?: string;
  isActivityLog?: boolean;
  dropDownDisabled?: boolean;
};

const DropdownContainer: React.FC<DropdownContainerType> = ({
  className,
  onChangeValue,
  title,
  infoMessage,
  menu = [],
  isActivityLog = false,
  dropDownDisabled = false,
}) => {
  let choices = deepClone(menu);

  if (!isActivityLog) choices = choices?.filter((c: Choices) => c?.label);
  const selected =
    title ||
    choices?.filter((c: Choices) => c?.selected === true)[0]?.title ||
    choices[0]?.title;

  const onSelectionChange = (choice: Choices) => {
    choices = choices?.map((el: Choices) => {
      const selectionCondition = isActivityLog
        ? el?.unique_key === choice?.unique_key
        : el?.unique_key === choice?.unique_key;

      if (selectionCondition){
        if (!isActivityLog) el.unique_key = choice?.unique_key;
        el.selected = true;
      } else {
        if (!isActivityLog) el.unique_key = '';
        el.selected = false;
      }

      return el;
    });
    onChangeValue(choices);
  };

  return (
    <DropdownField
      className={`${className}`}
      title={selected}
      onChangeValue={onSelectionChange}
      infoMessage={infoMessage && infoMessage}
      menu={choices}
      dropDownDisabled={dropDownDisabled}
    />
  );
};

export default DropdownContainer;
